import React, { FC } from 'react';
import ListItem from './list-item/list-item';

type Props = {
    items: { value: any, isSelected: boolean }[],
    onSelect: (index: number, item: any) => void,
    isStriped: boolean,
    isMultiSelect?: boolean,
    listItemClassName?: string
    stripedListItemClassName?: string,
    selectedListItemClassName?: string,
    listItemStyle?: string | undefined
}

const List: FC<Props> = ({ items = [], onSelect, isStriped = false, isMultiSelect = false,
    listItemClassName = 'p-1', stripedListItemClassName = 'p-2', selectedListItemClassName,listItemStyle = undefined }) => {
    const handleSelect = (i, item) => {
        if (!isMultiSelect) {
            items.forEach((item) => {
                if (item.isSelected) {
                    item.isSelected = false;
                }
            })
        }
        
        item.isSelected = item.isSelected ? false : true;
        onSelect(i, item.value);
    };

    const listItemClasses = listItemStyle ? listItemStyle: (isStriped ? `border ${stripedListItemClassName}` : `border-b border-solid ${listItemClassName} ${isMultiSelect ? 'pl-6' : ''}`)

    return (
        <ul id = 'searchLookUpListItemsId'>
            { items.map((item, i) => (
                <ListItem
                    key={`li-${i}`}
                    onSelect={() => handleSelect(i, item)}
                    isSelected={item.isSelected}
                    isStripe={isStriped && i % 2 === 0}
                    className={listItemClasses}
                    checkSelect={isMultiSelect}
                    selectedListItemClassName={selectedListItemClassName}>
                    {item.value}
                </ListItem>
            ))}
        </ul>
    );
}

export default List;
